import { render, staticRenderFns } from "./RELStatusViagens.vue?vue&type=template&id=a8ee8ef8&"
import script from "./RELStatusViagens.vue?vue&type=script&lang=js&"
export * from "./RELStatusViagens.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports